import React, { useState } from "react";

export default function HowToUse() {
  const [open, setOpen] = useState(null);

  const toggle = (i) => {
    setOpen(open === i ? null : i);
  };

  return (
    <div className="htu-container">
      <style>{`
        .htu-container {
          width: 100%;
          max-width: 1000px;
          margin: 80px auto;
          padding: 20px;
          font-family: "Poppins", sans-serif;
        }

        .htu-title {
          text-align: center;
          font-size: 38px;
          font-weight: 700;
          margin-bottom: 40px;
          color: #151515;
        }

        /* Accordion Box */
        .htu-box {
          background: #fff;
          padding: 18px 20px;
          margin-bottom: 18px;
          border-radius: 12px;
          box-shadow: 0 3px 10px rgba(0,0,0,0.08);
          border: 1px solid #eaeaea;
          cursor: pointer;
          transition: 0.2s ease;
        }

        .htu-box:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }

        .htu-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 20px;
          font-weight: 600;
          color: #222;
        }

        .htu-icon {
          font-size: 22px;
          transition: 0.3s;
        }

        /* Rotating icon */
        .rotate {
          transform: rotate(180deg);
        }

        /* Content */
        .htu-content {
          margin-top: 12px;
          padding-left: 5px;
          padding-right: 10px;
          line-height: 1.7;
          font-size: 16px;
          color: #555;
          animation: fadeIn 0.3s ease-in-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-3px); }
          to { opacity: 1; transform: translateY(0); }
        }

        ul {
          margin-top: 8px;
          padding-left: 20px;
        }

        li {
          margin-bottom: 8px;
        }

        @media(max-width: 600px) {
          .htu-title { font-size: 30px; }
          .htu-header { font-size: 18px; }
        }

      `}</style>

      <h1 className="htu-title">How to Use Vyango</h1>

      {/* SECTION 1 - SIGNUP */}
      <div className="htu-box" onClick={() => toggle(1)}>
        <div className="htu-header">
          <span>📝 How to Sign Up</span>
          <span className={`htu-icon ${open === 1 ? "rotate" : ""}`}>▼</span>
        </div>

        {open === 1 && (
          <div className="htu-content">
            <p>Follow these steps to create your Vyango account:</p>
            <ul>
              <li>Enter your <b>Full Name</b></li>
              <li>Enter your <b>Date of Birth</b></li>
              <li>Enter your <b>Email Address</b></li>
              <li>Create a <b>Password</b></li>
              <li>Enter your <b>Mobile Number</b></li>
              <li>You will receive an <b>OTP on your phone</b></li>
              <li>Enter the OTP to verify your number</li>
              <li>Your account is created successfully</li>
            </ul>
          </div>
        )}
      </div>

      {/* SECTION 2 - LOGIN */}
      <div className="htu-box" onClick={() => toggle(2)}>
        <div className="htu-header">
          <span>🔑 How to Log In</span>
          <span className={`htu-icon ${open === 2 ? "rotate" : ""}`}>▼</span>
        </div>

        {open === 2 && (
          <div className="htu-content">
            <ul>
              <li>Enter your <b>mobile number</b> or <b>email</b></li>
              <li>Enter your password</li>
              <li>Click <b>Login</b></li>
              <li>You will be redirected to the home page</li>
            </ul>
          </div>
        )}
      </div>

      {/* SECTION 3 - SEARCH A RIDE */}
      <div className="htu-box" onClick={() => toggle(3)}>
        <div className="htu-header">
          <span>🚗 How to Search for a Ride</span>
          <span className={`htu-icon ${open === 3 ? "rotate" : ""}`}>▼</span>
        </div>

        {open === 3 && (
          <div className="htu-content">
            <ul>
              <li>Go to the <b>Search</b> section</li>
              <li>Enter <b>Pickup Location</b></li>
              <li>Enter <b>Destination</b></li>
              <li>Select date</li>
              <li>Click <b>Search Rides</b></li>
            </ul>
          </div>
        )}
      </div>

      {/* SECTION 4 - REQUEST SEAT */}
      <div className="htu-box" onClick={() => toggle(4)}>
        <div className="htu-header">
          <span>📩 How to Request a Seat</span>
          <span className={`htu-icon ${open === 4 ? "rotate" : ""}`}>▼</span>
        </div>

        {open === 4 && (
          <div className="htu-content">
            <ul>
              <li>Open the ride you want to join</li>
              <li>Click <b>Request Seat</b></li>
              <li>Wait for the driver to accept your request</li>
              <li>You will receive a notification when accepted</li>
            </ul>
          </div>
        )}
      </div>

      {/* SECTION 5 - POST RIDE */}
      <div className="htu-box" onClick={() => toggle(5)}>
        <div className="htu-header">
          <span>🛣️ How to Post Your Own Ride</span>
          <span className={`htu-icon ${open === 5 ? "rotate" : ""}`}>▼</span>
        </div>

        {open === 5 && (
          <div className="htu-content">
            <ul>
              <li>Go to <b>Post Ride</b></li>
              <li>Enter pickup & destination</li>
              <li>Select date & time</li>
              <li>Enter available seats</li>
              <li>Set a price per seat</li>
              <li>Click <b>Post Ride</b></li>
            </ul>
          </div>
        )}
      </div>

      {/* SECTION 6 - COMPLETE RIDE */}
      <div className="htu-box" onClick={() => toggle(6)}>
        <div className="htu-header">
          <span>⭐ How to Rate a Ride</span>
          <span className={`htu-icon ${open === 6 ? "rotate" : ""}`}>▼</span>
        </div>

        {open === 6 && (
          <div className="htu-content">
            <ul>
              <li>After completing your ride</li>
              <li>Go to <b>Completed Rides</b></li>
              <li>Select the driver</li>
              <li>Give a rating from 1–5 stars</li>
              <li>Write a review (optional)</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}